var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.1052567,65.8421594 C85.9367483,65.8421594 79.8948025,64.8790007 74.1683998,62.9894432 C71.3736607,62.0262846 68.1999738,62.7683904 66.3632125,64.6421584 L55.0105716,73.2158497 C41.9842451,66.2632946 33.6473961,57.9316266 26.789578,45.000037 L35.1316078,33.9158174 C37.2316096,31.8158156 37.984324,28.7420467 37.0843233,25.8631792 C35.1789763,20.1000165 34.2106367,14.0526431 34.2106367,7.89474333 C34.2106367,3.54202594 30.6686107,0 26.3158934,0 L7.89474333,0 C3.54202594,0 0,3.54202594 0,7.89474333 C0,58.6789134 41.3210866,100 92.1052567,100 C96.4579741,100 100,96.4579741 100,92.1052567 L100,73.7369027 C100,69.3841853 96.4579741,65.8421594 92.1052567,65.8421594 Z",
    id: "ic_phone",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/ic_phone.a431e9ba3fc92d8c482f85f79334af8c.svg";
export { ForwardRef as ReactComponent };